import { create } from "zustand";

type Salary = {
  approved: boolean;
  employee: {
    _id: string;
    name: string;
    email: string;
  };
  createdAt: string | Date;
  netPay: number;
  totalEarnings: number;
  totalDeductions: number;
  notes: string;
  period: string;
  components: {
    type: string;
    amount: number;
    name: string;
    description: string;
  }[];
  id: string;
};

interface HookProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;

  salary: Salary | null;
  setSalary: (s: Salary | null) => void;
}

export const useSalaryModal = create<HookProps>()((set) => ({
  open: false,
  onOpenChange: (open) =>
    set(() => ({
      open,
    })),

  salary: null,
  setSalary: (s) =>
    set(() => ({
      salary: s,
    })),
}));
